<div id="report-page" class="page-body-content">
  <div id="reportStatus"></div>
  <div class="container">
    <div [hidden]="isReportLoaded" class="spinner-container">
      <div class="d-flex justify-content-center">
        <div class="spinner-border custom-spinner" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
  <div class="container">
    <div #reportContainer *ngIf="isReportLoaded" class="row flex-column-reverse flex-lg-row flex-xl-row">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
        <div [innerHTML]="reportBody | safeHtml"></div>
      </div>
    </div>
  </div>
</div>
